import React, { useEffect, useState } from 'react';
import CheckBox from '../../../../../atomic/formElements/checkBox/CheckBox';
import RestartPositionOnceSystemHasFlattenedDoc from '../../../documentation/RestartPositionOnceSystemHasFlattenedDocumentation';
import InfoIconComponent from '../InfoIcon';
import style from './Repeating.module.css';
import PropTypes from 'prop-types';
import NumberInputWithUnit from '../../../../../atomic/inputs/numberInputWithUnit/NumberInputWithUnit';
import {
  DeactivateOnRestartDocs,
  MaxLossDocs,
  MaxAttemptsDocs,
  MaxMinutesDocs,
} from '../../../documentation/RestartOptionsDocumentation';

const Repeating = ({
  top,
  dispatchTop,
  restartSettings,
  setRestartSettings,
}) => {
  const [maxLossTxt, setMaxLossTxt] = useState('');
  const [maxMinutesTxt, setMaxMinutesTxt] = useState('');
  const [maxAttemptsTxt, setAttemptsTxt] = useState('');
  const [maxTradesTxt, setMaxTradesTxt] = useState('');

  useEffect(() => {
    setMaxLossTxt(restartSettings.maxLoss || 0);
    setMaxMinutesTxt(restartSettings.maxMinutesInTradePlan || 0);
    setAttemptsTxt(restartSettings.maxRestartAttempts || 0);
    setMaxTradesTxt(restartSettings.numberOfTrades || 0);
  }, [restartSettings]);

  return (
    <div className={style.container}>
      <div className={style.top}>
        <div className={style.checkboxAndTooltip}>
          <CheckBox
            margin="0 3px 0 0"
            checked={top.restartSystemOncePositionHasFlattened}
            onChange={(checked) =>
              dispatchTop({
                restartSystemOncePositionHasFlattened: checked,
              })
            }
          >
            Repeating
          </CheckBox>
          <InfoIconComponent docs={RestartPositionOnceSystemHasFlattenedDoc} />
        </div>
      </div>
      {top.restartSystemOncePositionHasFlattened && (
        <div className={style.outerOptions}>
          <div className={style.checkboxAndTooltip}>
            <CheckBox
              margin="0 3px 0 0"
              checked={restartSettings.deactivateOnRestart}
              onChange={(checked) =>
                setRestartSettings((prevState) => ({
                  ...prevState,
                  deactivateOnRestart: checked,
                }))
              }
            >
              Deactivate on Restart
            </CheckBox>
            <InfoIconComponent docs={DeactivateOnRestartDocs} />
          </div>
          <div className={style.options}>
            <div className={style.checkAndInput}>
              <div className={style.checkboxAndTooltip}>
                <CheckBox
                  margin="0 3px 0 0"
                  checked={restartSettings.isMaxLoss}
                  onChange={(checked) =>
                    setRestartSettings((prevState) => ({
                      ...prevState,
                      isMaxLoss: checked,
                    }))
                  }
                >
                  Max Loss
                </CheckBox>
                <InfoIconComponent docs={MaxLossDocs} />
              </div>
              <NumberInputWithUnit
                direction="left"
                type="number"
                value={maxLossTxt}
                setValue={(value) => setMaxLossTxt(value)}
                onBlur={(value) =>
                  setRestartSettings((prevState) => ({
                    ...prevState,
                    maxLoss: parseFloat(value),
                  }))
                }
              >
                $
              </NumberInputWithUnit>
            </div>

            <div className={style.checkAndInput}>
              <div className={style.checkboxAndTooltip}>
                <CheckBox
                  margin="0 3px 0 0"
                  checked={restartSettings.isNumberOfTrades}
                  onChange={(checked) =>
                    setRestartSettings((prevState) => ({
                      ...prevState,
                      isNumberOfTrades: checked,
                    }))
                  }
                >
                  Max Trades
                </CheckBox>
                <InfoIconComponent docs={MaxAttemptsDocs} />
              </div>
              <NumberInputWithUnit
                direction="left"
                type="number"
                value={maxTradesTxt}
                setValue={(value) => setMaxTradesTxt(value)}
                onBlur={(value) =>
                  setRestartSettings((prevState) => ({
                    ...prevState,
                    numberOfTrades: parseFloat(value),
                  }))
                }
              >
                #
              </NumberInputWithUnit>
            </div>
            <div className={style.checkAndInput}>
              <div className={style.checkboxAndTooltip}>
                <CheckBox
                  margin="0 3px 0 0"
                  checked={restartSettings.isMaxRestartAttempts}
                  onChange={(checked) =>
                    setRestartSettings((prevState) => ({
                      ...prevState,
                      isMaxRestartAttempts: checked,
                    }))
                  }
                >
                  Max Attempts
                </CheckBox>
                <InfoIconComponent docs={MaxAttemptsDocs} />
              </div>
              <NumberInputWithUnit
                direction="left"
                type="number"
                value={maxAttemptsTxt}
                setValue={(value) => setAttemptsTxt(value)}
                onBlur={(value) =>
                  setRestartSettings((prevState) => ({
                    ...prevState,
                    maxRestartAttempts: parseFloat(value),
                  }))
                }
              >
                #
              </NumberInputWithUnit>
            </div>
            <div className={style.checkAndInput}>
              <div className={style.checkboxAndTooltip}>
                <CheckBox
                  margin="0 3px 0 0"
                  checked={restartSettings.isMaxMinutesInTradePlan}
                  onChange={(checked) =>
                    setRestartSettings((prevState) => ({
                      ...prevState,
                      isMaxMinutesInTradePlan: checked,
                    }))
                  }
                >
                  Max Minutes
                </CheckBox>
                <InfoIconComponent docs={MaxMinutesDocs} />
              </div>
              <NumberInputWithUnit
                direction="right"
                type="number"
                value={maxMinutesTxt}
                setValue={(value) => setMaxMinutesTxt(value)}
                onBlur={(value) =>
                  setRestartSettings((prevState) => ({
                    ...prevState,
                    maxMinutesInTradePlan: parseFloat(value),
                  }))
                }
              >
                min.
              </NumberInputWithUnit>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
Repeating.propTypes = {
  top: PropTypes.object.isRequired,
  dispatchTop: PropTypes.func.isRequired,
  restartSettings: PropTypes.object.isRequired,
  setRestartSettings: PropTypes.func.isRequired,
};
export default Repeating;
